import { Component, type ErrorInfo, type ReactNode } from 'react';
import { novoRequestId, codigoCurto } from '../lib/api';
import { dict } from '../lib/dict';
import { relatarErro } from '../lib/rastreio';

interface Estado {
  readonly codigo: string | null;
}

export class ErroDaTela extends Component<{ children: ReactNode }, Estado> {
  override state: Estado = { codigo: null };

  static getDerivedStateFromError(): Estado {
    return { codigo: codigoCurto(novoRequestId()) };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    const comComponente = new Error(error.message);
    comComponente.name = error.name;
    comComponente.stack = `${error.stack ?? ''}\n--- componentes ---${info.componentStack ?? ''}`;
    relatarErro('react', comComponente, this.state.codigo ?? undefined);
  }

  override render(): ReactNode {
    if (this.state.codigo === null) return this.props.children;
    const t = dict().erroDaTela;
    return (
      <div className="erro-da-tela" role="alert">
        <h1>{t.title}</h1>
        <p>{t.lede}</p>
        <p className="muted">{t.codigo(this.state.codigo)}</p>
        <button className="btn btn--primary" type="button" onClick={() => window.location.reload()}>
          {t.recarregar}
        </button>
      </div>
    );
  }
}
